import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { tap } from 'rxjs/operators';
import { BaseService } from 'src/app/core/services/base.service';
import {
	ILoginUsuario,
	IRecoverPasswordUsuario,
	IUpdatePasswordUsuario
} from '../../authentication/models/UserSession.model';
import { ILocalidad } from '../models/ILocalidad';
import { ICombo } from '../models/combo.model';
import { NuevoUsuario, Usuario } from '../models/usuario.model';

@Injectable({
	providedIn: 'root',
})
export class UsuarioService {
	constructor(protected http: HttpClient, private service: BaseService) {}

	add(body: Usuario) {
		return this.service.doPost('api/Auth/addUser', body);
	}

	addNew(body: NuevoUsuario): Observable<Response> {
		return this.service.doPost('api/Auth/register', body);
	}
	login(body: ILoginUsuario) {
		
		return this.http.post<ILoginUsuario>(this.service.endPoint + 'api/Auth/authenticate', body);
	}

	sendRecoverPassword(body: IRecoverPasswordUsuario) {
		return this.service.doPost('api/Auth/resetPassword', body);
	}

	update(body: Usuario) {
		return this.service.doPut('api/Auth/updateUser', body);
	}

	updatePasswordLogin(body: IUpdatePasswordUsuario) {
		return this.service.doPut('api/Auth/updatePasswordLogin', body);
	}
	updatePassword(body: IUpdatePasswordUsuario) {
		return this.service.doPut('api/Auth/updatePassword', body);
	}
	delete(id: number) {
		return this.service.doDelete('api/Auth/deleteUser?id=' + id).pipe<boolean>(
			tap((response: any) => {
				return response;
			})
		);
	}

	getById(id: number) {
		return this.service.doGet('api/Usuarios/getById?id=' + id).pipe<Usuario>(
			tap((response: any) => {
				return response;
			})
		);
	}

	getAll(idEmpresa: number) {
		return this.service.doGet('api/Usuarios/getUsuariosByEmpresa?idEmpresa=' + idEmpresa).pipe<Usuario[]>(
			tap((response: any) => {
				return response;
			})
		);
	}

	getLocalidades(): Observable<ILocalidad[]> {
		return this.service.doGet('api/Usuarios/getLocalidades').pipe<ILocalidad[]>(
			tap((response: any) => {
				return response;
			})
		);
	}

	getRoles(): Observable<ICombo[]> {
		return this.service.doGet('api/Auth/getRoles').pipe<ICombo[]>(
			tap((response: any) => {
				return response;
			})
		);
	}
	
}
